export const IMAGES = {
  // Logos
  uLearnLogo: require('../assets/media/uLearn-logo.svg').default,
  uLearnLogoWhite: require('../assets/media/uLearnWhiteLogo.svg').default,
  // Images
  teacherPhone: require('../assets/media/teacherPhone.png'),
  parentsPhone: require('../assets/media/parentsPhone.png'),
  homeThumbnail: require('../assets/media/homeClassRoom.webp'),
  forSchool: require('../assets/media/forSchool.webp'),
  forVendor: require('../assets/media/forVendors.webp'),
  whoWeAre: require('../assets/media/whoWeAre.webp'),
  whatWeDo: require('../assets/media/whatWeDo.webp'),
  boys: require('../assets/media/boys.webp'),
  number1: require('../assets/media/Number1.svg').default,
  number2: require('../assets/media/Number2.svg').default,
  number3: require('../assets/media/Number3.svg').default,
  quote: require('../assets/media/quote.svg').default,
  //Icons
  locationIcon: require('../assets/media/location.svg').default,
  phoneIcon: require('../assets/media/phone.svg').default,
  emailIcon: require('../assets/media/email.svg').default,
  locationIconWhite: require('../assets/media/locationWhite.svg').default,
  phoneIconWhite: require('../assets/media/phoneWhite.svg').default,
  emailIconWhite: require('../assets/media/emailWhite.svg').default,
  // stores
  googleStore: require('../assets/media/google.png'),
  appleStore: require('../assets/media/appstore.png'),
  // SVG's
  facebookIcon: require('../assets/media/Facebook.svg').default,
  linkedinIcon: require('../assets/media/LinkedIn.svg').default,
  twitterIcon: require('../assets/media/Twitter.svg').default,
  // Background-Images
  downloadUlearn: require('../assets/media/download-ulearn1.png'),
};
